import { get } from '..';

const getRoles = () => get('users/roles');

export default getRoles;
